<template>
  <g>
    <path
      d="M12.8001 5.1999C12.5602 4.96006 12.1602 4.96006 11.9204 5.1999L8.99998 8.1203L6.09998 5.1999C5.86014 4.96006 5.46014 4.96006 5.2203 5.1999C4.98046 5.43974 4.98046 5.83974 5.2203 6.07958L8.1203 8.99998L5.1999 11.9C4.96006 12.1398 4.96006 12.5398 5.1999 12.7797C5.32021 12.9 5.47958 12.9593 5.63974 12.9593C5.7999 12.9593 5.96006 12.8992 6.07958 12.7797L8.99998 9.87966L11.9 12.8001C12.0203 12.9204 12.1797 12.9797 12.3398 12.9797C12.5 12.9797 12.6601 12.9196 12.7797 12.8001C13.0195 12.5602 13.0195 12.1602 12.7797 11.9204L9.87966 8.99998L12.8001 6.09998C13.0399 5.83982 13.0399 5.46014 12.8001 5.19998V5.1999Z"
      fill="white"
    />
    <path
      d="M9 0C4.0204 0 0 4.0204 0 9C0 13.9796 4.0204 18 9 18C13.9796 18 18 13.9796 18 9C18 4.0204 13.9796 0 9 0ZM14.4796 14.4796C13.0194 15.9398 11.0796 16.7398 9 16.7398C6.9398 16.7398 4.9796 15.9398 3.5204 14.4796C2.06024 13.0194 1.2602 11.0796 1.2602 9C1.2602 6.9398 2.0602 4.9796 3.5204 3.5204C4.98056 2.06024 6.9204 1.2602 9 1.2602C11.0602 1.2602 13.0204 2.0602 14.4796 3.5204C15.9398 4.98056 16.7398 6.9204 16.7398 9C16.7398 11.0602 15.9398 13.0204 14.4796 14.4796Z"
      fill="white"
    />
  </g>
</template>
<script>
export default {
  name: 'icon-circle-x',
}
</script>
